// extracted by mini-css-extract-plugin
export var container_tiny = "faq-module--container_tiny--lsuj9";
export var huj = "faq-module--huj--h3bM+";